import React from 'react';
import { Button } from '@strapi/design-system';
import { createLink, editLink, removeLInk } from '../../utils';
import useCreateGlossary from './../../../../../../../glossary/admin/src/api/use-create-glossary';
import styles from './ButtonsRow.module.css';
import { GlossaryConst } from '../../utils';
import { useNotification } from '@strapi/helper-plugin';
import { NOTIFICATION_WARNING, NOTIFICATION_SUCCESS } from '#shared/utils/constants';
const ButtonsRow = ({
  currentItem,
  handleClose,
  editor,
  isSelected,
  isCreateLink,
  selectedText,
  isGlossaryTerm,
  businessLine,
  isSaveButtonDisabled
}) => {
  const {
    createGlossary
  } = useCreateGlossary();
  const notify = useNotification();
  const handleSubmit = () => {
    if (!currentItem?.id && !currentItem?.term && isSelected && isGlossaryTerm) {
      removeLInk(editor, handleClose);
      return;
    }
    if (!currentItem.term) {
      return;
    }
    if (!currentItem.id) {
      createGlossary({
        term: currentItem.term,
        definition: currentItem.definition,
        business_line: businessLine
      }).then(response => {
        if (typeof response === 'string') {
          notify({
            type: NOTIFICATION_WARNING.type,
            message: response
          });
          return;
        }
        if (!isSelected) {
          return;
        }
        createOrEditLink(isCreateLink, response.uuid, response.term, isGlossaryTerm, handleClose);
      });
    } else {
      createOrEditLink(isCreateLink, currentItem.uuid, currentItem.term);
    }
  };
  const notifySuccess = () => {
    notify({
      type: NOTIFICATION_SUCCESS.type,
      message: NOTIFICATION_SUCCESS.message
    });
  };
  const createOrEditLink = (isCreateLink, id, term, isGlossaryTerm) => {
    if (isCreateLink) {
      createLink(editor, selectedText, id, term, isGlossaryTerm, handleClose);
    } else {
      editLink(editor, id, term, handleClose);
    }
    notifySuccess();
  };
  if (!selectedText.trim()) {
    isSelected = false;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: () => handleClose()
  }, GlossaryConst.CLOSE), /*#__PURE__*/React.createElement(Button, {
    disabled: !isSelected || isSaveButtonDisabled,
    variant: "primary",
    onClick: () => handleSubmit()
  }, isGlossaryTerm && !currentItem?.term ? GlossaryConst.UNLINK : !currentItem?.id ? GlossaryConst.SAVE_AND_LINK : GlossaryConst.LINK));
};
export default ButtonsRow;